import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from '../helpers/emblaDots';
import Autoplay from 'embla-carousel-autoplay';
const selectors = {
    heroBannerCarousel: '[data-hero-banner-carousel]',
    heroBannerCarouselAutoplay: 'data-hero-banner-carousel-autoplay',
    heroBannerCarouselSpeed: 'data-hero-banner-carousel-speed',
    heroBannerCarouselViewport: '[data-hero-banner-carousel-viewport]',
    heroBannerCarouselPrev: '[data-hero-banner-carousel-prev]',
    heroBannerCarouselNext: '[data-hero-banner-carousel-next]',
    heroBannerCarouselDots: '[data-hero-banner-carousel-dots]',
    heroBannercarouselSlide: '.banner__slide',
};
const bannerCarousel = () => {
    const heroBannerCarousels = document.querySelectorAll(selectors.heroBannerCarousel);
    if (heroBannerCarousels) {
        heroBannerCarousels.forEach((carousel) => {
            let embla;
            const speed = parseInt(carousel.getAttribute(selectors.heroBannerCarouselSpeed));
            const viewportNode = carousel.querySelector(selectors.heroBannerCarouselViewport);
            const prevButtonNode = carousel.querySelector(selectors.heroBannerCarouselPrev);
            const nextButtonNode = carousel.querySelector(selectors.heroBannerCarouselNext);
            const dotsNode = carousel.querySelector(selectors.heroBannerCarouselDots);
            const options = {
                loop: true,
                align: 'start',
            };
            if (carousel.getAttribute(selectors.heroBannerCarouselAutoplay) == 'true') {
                embla = EmblaCarousel(viewportNode, options, [Autoplay({ playOnInit: true, delay: speed, stopOnInteraction: false, stopOnMouseEnter: true })]);
            }
            else {
                embla = EmblaCarousel(viewportNode, options);
            }
            if (dotsNode) {
                addDotBtnsAndClickHandlers(embla, dotsNode);
            }
            if (prevButtonNode && nextButtonNode) {
                prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
                nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
            }
            // Countdown Timer
            const slides = carousel.querySelectorAll(selectors.heroBannercarouselSlide);
            slides.forEach((slide) => {
                let timeToEnd;
                let countDownDate;
                const getCountDownString = () => {
                    const now = new Date().getTime();
                    timeToEnd = countDownDate - now;
                    const days = Math.floor(timeToEnd / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((timeToEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeToEnd % (1000 * 60)) / 1000);
                    const dayString = days < 10 ? `<div><span>0${days}</span><span>days</span></div>` : `<div><span>${days}</span><span>days</span></div>`;
                    const hoursString = hours < 10 ? `<div><span>0${hours}</span><span>hours</span></div>` : `<div><span>${hours}</span><span>hours</span></div>`;
                    const minutesString = minutes < 10 ? `<div><span>0${minutes}</span><span>minutes</span></div>` : `<div><span>${minutes}</span><span>minutes</span></div>`;
                    const secondsString = seconds < 10 ? `<div><span>0${seconds}</span><span>seconds</span></div>` : `<div><span>${seconds}</span><span>seconds</span></div>`;
                    return `${dayString}<div><span>:</span></div>${hoursString}<div><span>:</span></div>${minutesString}<div><span>:</span></div>${secondsString}`;
                };
                const countdown = slide.querySelector('[data-countdown]');
                if (countdown) {
                    const href = slide?.getAttribute('href');
                    if (href) {
                        slide.removeAttribute('href');
                    }
                    const date = new Date(countdown?.attributes['data-countdown-endtime']?.value);
                    const countdownHideSlideAtEnd = countdown?.getAttribute('data-countdown-hide-slide');
                    const contentDiv = countdown.querySelector('[data-countdown-timer]');
                    const now = new Date().getTime();
                    countDownDate = date.getTime();
                    timeToEnd = countDownDate - now;
                    if (timeToEnd >= 0) {
                        contentDiv.innerHTML = getCountDownString();
                    }
                    else if (timeToEnd <= 0) {
                        if (countdownHideSlideAtEnd == 'true') {
                            slide.remove();
                        }
                        else {
                            if (href) {
                                slide.setAttribute('href', href);
                            }
                            countdown.remove();
                            slide.classList.remove('banner__slide--countdown');
                        }
                    }
                    const countDownTimer = setInterval(() => {
                        contentDiv.innerHTML = getCountDownString();
                        if (timeToEnd <= 0) {
                            if (countdownHideSlideAtEnd == 'true') {
                                slide.remove();
                            }
                            else {
                                if (href) {
                                    slide.setAttribute('href', href);
                                }
                                slide.classList.remove('banner__slide--countdown');
                                countdown.remove();
                            }
                            clearInterval(countDownTimer);
                        }
                    }, 1000);
                }
            });
        });
    }
};
export { bannerCarousel };
